var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import * as auth0 from 'auth0-js';
import { Config } from '../../config/config';
import { JwtHelper, tokenNotExpired } from 'angular2-jwt';
//import { LocalStorageService } from '../../localstorage.service';
var AuthError = (function () {
    function AuthError() {
    }
    return AuthError;
}());
export var AuthConfig = {
    scope: 'openid',
    responseType: 'token id_token',
    clientID: Config.getEnvironmentVariable("auth0ClientID"),
    domain: Config.getEnvironmentVariable("auth0Domain"),
    connection: 'Username-Password-Authentication',
};
var AuthService = (function () {
    function AuthService(router) {
        this.router = router;
        //private localStorage: LocalStorageService
        this.auth0 = new auth0.WebAuth({
            clientID: AuthConfig['clientID'],
            domain: AuthConfig['domain'],
            responseType: AuthConfig['responseType'],
            scope: AuthConfig['scope']
        });
        this.jwtHelper = new JwtHelper();
    }
    AuthService.prototype.login = function (username, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth0.client.login({
                connection: AuthConfig['connection'],
                username: username,
                password: password,
                scope: AuthConfig['scope'],
                realm: AuthConfig['connection'],
            }, function (err, authResult) {
                if (err) {
                    var error = void 0;
                    error = {
                        code: err.code,
                        description: err.description
                    };
                    reject(error);
                    return;
                }
                window.localStorage.setItem("accessToken", authResult.accessToken);
                window.localStorage.setItem("token", authResult.idToken);
                resolve();
            });
        });
    };
    AuthService.prototype.signup = function (email, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth0.signup({
                connection: AuthConfig['connection'],
                email: email,
                password: password,
            }, function (err) {
                if (err) {
                    var error = void 0;
                    error = {
                        code: err.code,
                        description: err.description
                    };
                    reject(error);
                    return;
                }
                resolve();
            });
        });
    };
    AuthService.prototype.changePassword = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth0.changePassword({
                connection: AuthConfig['connection'],
                email: email,
            }, function (err, resp) {
                if (err) {
                    var error = void 0;
                    error = {
                        code: err.code,
                        description: err.description
                    };
                    reject(error);
                    return;
                }
                else {
                    console.log(resp);
                    resolve();
                }
            });
        });
    };
    AuthService.prototype.getProfile = function () {
        return this.jwtHelper.decodeToken(window.localStorage.getItem('token'));
    };
    AuthService.prototype.loggedIn = function () {
        // checks whether a JWT exists in local storage, and if it does, whether it has expired or not
        // remove the expired token
        if (!tokenNotExpired()) {
            window.localStorage.removeItem("accessToken");
            window.localStorage.removeItem('token');
        }
        return tokenNotExpired();
    };
    AuthService.prototype.logout = function () {
        window.localStorage.removeItem("accessToken");
        window.localStorage.removeItem('token');
        this.router.navigate(["/"]);
    };
    AuthService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Router])
    ], AuthService);
    return AuthService;
}());
export { AuthService };
//# sourceMappingURL=auth.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/auth.service.js
// module id = 39
// module chunks = 0